import React from "react"
import { ConnectDropTarget, DropTarget, DropTargetConnector } from "react-dnd"
import DraggableItem, { DraggableTypeItem } from "./DraggableItem"
import DraggableItemData from "./DraggableItemData"

export interface DroppableContainerProps {
  items: DraggableItemData[]
  onChangeItemsList: (items: DraggableItemData[]) => void
}

interface DroppableContainerPropsExt extends DroppableContainerProps {
  connectDropTarget: ConnectDropTarget
}

const DroppableItemTarget = { canDrop: () => true }

const DroppableItemCollect = (connect: DropTargetConnector) => ({ connectDropTarget: connect.dropTarget() })

class DroppableContainer extends React.Component<DroppableContainerPropsExt> {
  moveItem = (id: string, atIndex: number) => {
    const { item, index } = this.findItem(id)
    if (item) {
      const newItems = [...this.props.items]
      const prevItem = newItems.splice(atIndex, 1, item)
      newItems.splice(index, 1, prevItem[0])
      this.props.onChangeItemsList(newItems)
    }
  }

  excludeItem = (id: string, exclude: boolean) => {
    const { item, index } = this.findItem(id)
    if (item) {
      const newItems = [...this.props.items]
      newItems[index].exclude = exclude
      this.props.onChangeItemsList(newItems)
    }
  }

  findItem = (id: string) => {
    const item = this.props.items.filter((c) => c.id === id)[0]
    return {
      item: item,
      index: this.props.items.indexOf(item),
    }
  }

  render() {
    const { connectDropTarget } = this.props
    return connectDropTarget(
      <div>
        {this.props.items.map(item => <DraggableItem key={item.id}
          item={item}
          moveItem={this.moveItem}
          findItem={this.findItem}
          excludeItem={this.excludeItem}
          />
        )}
      </div>
    )
  }
}

export default DropTarget(DraggableTypeItem, DroppableItemTarget, DroppableItemCollect)(DroppableContainer)
